export const SET_RELATION_TYPE = 'SET_RELATION_TYPE';
export const SET_TARGET_DOCUMENT = 'SET_TARGET_DOCUMENT';
export const CONNECTION_CREATED = 'CONNECTION_CREATED';
//UI
export const OPEN_CONNECTION_PANEL = 'OPEN_CONNECTION_PANEL';
export const CLOSE_CONNECTION_PANEL = 'CLOSE_CONNECTION_PANEL';
export const SEARCHING_CONNECTIONS = 'SEARCHING_CONNECTIONS';
export const CREATING_CONNECTION = 'CREATING_CONNECTION';
export const CREATING_RANGED_CONNECTION = 'CREATING_RANGED_CONNECTION';
export const CANCEL_RANGED_CONNECTION = 'CANCEL_RANGED_CONNECTION';